// extracted by mini-css-extract-plugin
export default {"pageWrap":"zb-z","fullWidth":"Ab-z","heading":"Bb-z","fullBleed":"Cb-z","hidden":"Db-z"};